import { render } from "./Height.svg?vue&type=template&id=7c9a9968"
const script = {}
script.render = render

export default script